import React from "react";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>Dacom</p>
      </header>
    </div>
  );
}

export default App;
